// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"165391a3","566":"3870d476","638":"232526d5","840":"2574aac7"}[chunkId] + ".chunk.css";
};